@if(!browserInited) {

<div class="d-flex align-items-center justify-content-center image-viewer-bg" style="height: 100vh;">
    <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">로딩 중...</span>
    </div>
</div>

} @else {

<div class="modal-header">
    <h4 class="modal-title">사진 상세보기</h4>
    <!-- 몇 번째 사진인지와 제목·파일명 -->
    @if (images.length) {
    <div class="image-caption text-truncate">
        <span class="fw-bold">{{ activeIndex + 1 }} / {{ images.length }}</span>
        @if (getImageTitle(images[activeIndex])) {
        <span class="ms-2">{{ getImageTitle(images[activeIndex]) }}</span>
        }
        <span class="ms-2 image-caption-file">{{ getImageFilename(images[activeIndex]) }}</span>
    </div>
    }
    <div class="d-flex gap-1">
        <button type="button" class="btn btn-light btn-sm" (click)="modalCtrl.activeModal.dismiss()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>

<div class="d-flex flex-column overflow-hidden" style="height: calc(100vh - 40px);">

    @if (images.length) {

    <div class="d-flex flex-column h-100">

        <!-- 상세보기 영역 -->
        <div class="flex-grow-1 overflow-hidden position-relative">

            <ngb-carousel #carousel class="h-100" [interval]="0" [pauseOnHover]="true" [pauseOnFocus]="true"
                [showNavigationArrows]="true" [showNavigationIndicators]="false" [keyboard]="false"
                [activeId]="'slide-' + activeIndex" (slide)="onSlide($event)">

                @for (image of images; track $index) {
                <ng-template ngbSlide [id]="'slide-' + $index">
                    <div class="d-flex align-items-center justify-content-center image-viewer-bg overflow-hidden image-viewer"
                        style="height: calc(100vh - 140px);" (wheel)="onWheel($event)">

                        @if (!isImageLoaded($index)) {
                        <div class="position-absolute top-50 start-50 translate-middle">
                            <div class="spinner-border text-light" role="status">
                                <span class="visually-hidden">이미지 로딩 중...</span>
                            </div>
                        </div>
                        }

                        @if (isImageLoadFailed($index)) {
                        <div class="position-absolute top-50 start-50 translate-middle text-center text-light">
                            <i class="fa-solid fa-triangle-exclamation fa-3x mb-3"></i>
                            <div>이미지를 불러올 수 없습니다</div>
                        </div>
                        }

                        <!-- transition: transform 0.15s ease; -->
                        <img #zoomImage class="img-fluid object-fit-contain zoom-image"
                            style="max-width: 100%; max-height: 100%; "
                            [class.invisible]="!isImageLoaded($index) || isImageLoadFailed($index)"
                            [style.transform]="getImageTransform()" [style.cursor]="zoom > 1 ? 'grab' : 'default'"
                            draggable="false" [src]="getImageUrl(image)" [alt]="getImageFilename(image)"
                            (load)="imageLoadComplete($index)" (error)="imageLoadFailed($index)"
                            (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
                            (pointerup)="onPointerUp($event)" (pointercancel)="onPointerUp($event)"
                            (dblclick)="toggleZoom()" />
                    </div>
                </ng-template>
                }

            </ngb-carousel>

            <!-- 확대/축소/회전 버튼 영역 -->
            <div class="image-zoom-controls d-flex gap-4 p-2">
                <div class="d-flex gap-1">
                    <button type="button" class="btn btn-light" (click)="zoomOut()" [disabled]="zoom <= 1" title="축소 (마우스 휠)">
                        <i class="fa-solid fa-magnifying-glass-minus"></i>
                    </button>

                    <button type="button" class="btn btn-light" (click)="resetZoom()" title="원래 크기 (더블클릭)">
                        {{ zoom * 100 | number:'1.0-0' }}%
                    </button>

                    <button type="button" class="btn btn-light" (click)="zoomIn()" [disabled]="zoom >= 5" title="확대 (마우스 휠)">
                        <i class="fa-solid fa-magnifying-glass-plus"></i>
                    </button>
                </div>
                <div class="d-flex gap-1">
                    <button type="button" class="btn btn-light" (click)="rotateLeft()" title="왼쪽으로 회전">
                        <i class="fa-solid fa-rotate-left"></i>
                    </button>

                    <button type="button" class="btn btn-light" (click)="rotateRight()" title="오른쪽으로 회전">
                        <i class="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
                <!-- 원본 열기·다운로드 -->
                <div class="d-flex gap-1">
                    <a class="btn btn-light" [href]="getImageUrl(images[activeIndex])" target="_blank" title="원본 열기 (새 탭)">
                        <i class="fa-solid fa-up-right-from-square"></i>
                    </a>
                    <a class="btn btn-light" [href]="getImageUrl(images[activeIndex])"
                        [attr.download]="getImageFilename(images[activeIndex]) || ''" title="다운로드">
                        <i class="fa-solid fa-download"></i>
                    </a>
                </div>
            </div>

        </div>

        <!-- 썸네일 영역 -->
        <div #thumbnailList class="s-image d-flex gap-2 p-2 overflow-x-auto flex-shrink-0">
            @for (image of images; track $index) {
            <button type="button" class="btn p-1 flex-shrink-0 thumbnail-btn" [class.active]="$index === activeIndex"
                style="width: 100px; height: 80px;" (click)="selectImage($index)">
                <img class="w-100 h-100 object-fit-cover rounded" [src]="getImageUrl(image) + '?thumbnail=0x120'"
                    [alt]="getImageFilename(image)" />
            </button>
            }
        </div>

    </div>

    } @else {
    <div class="d-flex align-items-center justify-content-center h-100 text-muted">
        등록된 사진이 없습니다
    </div>
    }

</div>

}
